// export const REACT_APP_CLIENT_URL =
//   process.env.REACT_APP_CLIENT_URL || "https://www.app.careersheets.in/";
// export const REACT_APP_FORM_LINK =
//   process.env.REACT_APP_FORM_LINK || "http://forms.gle/WVbVQw2hqrvrJaVB8";
// export const REACT_APP_SERVER_URL =
//   process.env.REACT_APP_SERVER_URL || "https://www.app.careersheets.in/api";


export const REACT_APP_CLIENT_URL =
  process.env.REACT_APP_CLIENT_URL ||
  "https://dev-ins-careersheets-dev.onrender.com/";
export const REACT_APP_FORM_LINK =
  process.env.REACT_APP_FORM_LINK || "http://forms.gle/WVbVQw2hqrvrJaVB8";
export const REACT_APP_SERVER_URL =
  process.env.REACT_APP_SERVER_URL ||
  "https://dev-ins-careersheets-dev.onrender.com/api";
